import React, {FC, ReactElement} from 'react';
import ElementsClass from './Elements';
import styled from 'styled-components';
import './Element.scss';

export type ElementProps = {
    index: number | null,
    path: {
        slideIndex: number,
        comboIndex: number,
        setIndex: number,
        groupIndex: number,
        elementIndex: number | null,
        subElementIndex: number|null
    } | null,
    editorPlugins: any | null,
    elementData: any,
}

type ElementDesignedProps = {
    separatorPlaceholder:string|null,
    horizontalAlignment: string,
    isAnchorActive?: boolean,
    selectedLinkType?: string|null,
}

export const ElementDesigned = styled.div<ElementDesignedProps>`
&[data-anchor-trigger] {
    cursor: ${props => (props.isAnchorActive && !props.selectedLinkType) || props.selectedLinkType !== 'none' ? 'pointer' : 'auto'};
}
&.elementWrapper {
    .content {
        text-align: left;
        ${props => props.horizontalAlignment === 'center' && `
            text-align: center;
        `};             
    }
}

`;

const Element: FC<ElementProps> = ({...props}): ReactElement => {

    let isEditor = props.editorPlugins;
    const elementsClass = new ElementsClass();
    let elementObject = elementsClass.getElement(props.elementData.name);
    let Element = elementObject[props.elementData.name];


    const settings = elementObject.settings;
    const elementOptions = elementObject.options;
    const elementLabel = elementObject.label;

    function handleClick(event:any) {
        const triggerElement:any = event.currentTarget;
        const currentTrigger = triggerElement.getAttribute('data-anchor-trigger');
        const anchorTargetElement = document.querySelector('[data-anchor-target="'+currentTrigger+'"]');
        if(!anchorTargetElement || (props.elementData.data.selectedLinkType && props.elementData.data.selectedLinkType !== 'anchor')) return;
        anchorTargetElement.scrollIntoView();
    }

    if (isEditor) {
        const ElementEditor = require('./ElementEditor').default
        return <ElementEditor {...props} element={Element} settings={settings} options={elementOptions} label={elementLabel} />;
    }
    else {
        return (
            <ElementDesigned className={'elementWrapper '} data-anchor-trigger={props.elementData.data.anchorTrigger} data-anchor-target={props.elementData.data.isAnchorActive ? props.elementData.data.anchorName : ''} separatorPlaceholder={null}
                onClick={(event) => {handleClick(event)}} horizontalAlignment={props.elementData.data.horizontalAlignment} isAnchorActive={props.elementData.data.isAnchorActive} selectedLinkType={props.elementData.data.selectedLinkType}>
                <Element {...props.elementData.data} editorPlugins={null}/>
            </ElementDesigned>
        )
    }

};


export default Element;
